import { render, staticRenderFns } from "./IconSvgDCAT.vue?vue&type=template&id=9d6f2994&scoped=true&"
import script from "./IconSvgDCAT.vue?vue&type=script&lang=js&"
export * from "./IconSvgDCAT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6f2994",
  null
  
)

export default component.exports